import React from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter'
import Callback from './Callback';
import ShiftingProcess from './ShiftingProcess';
import WorkProcess from './WorkProcess';
import helpdeskdetails from "../images/Helpdesk.jpg";
import Contactform from './Contactfrom';

function International() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="Gray"/>
      <div className='packermovershoogle'>
        <div className="album py-0">

          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#"><small>Home</small></Link></li>
                <li className="breadcrumb-item active" aria-current="page"><small>International Move</small></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

    <div style={{
        backgroundImage: "url(" + "https://i.postimg.cc/4dmHbnCZ/International-shift.jpg" + ")",
        backgroundPosition: 'start',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
       
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-2">
                    <button className='iba'>IBA Approved Packers and Movers</button>
                <h1 style={{ fontSize: "3rem", color: "#053168ff" }} className="card-text mb-0"> <b>Best International Relocation Services in India</b></h1>

                <h6 style={{ color: "white" }} className="card-text mb-5 mt-4"> Customs Clearance Expertise – Hassle-free documentation & compliance.</h6>
   <h1 className="card-text " style={{ margin: "auto 0", color: "white" }}> <b> Best International Relocation Services in :  <span style={{ fontWeight: "bold", marginleft: '10px', color: "white" }}>
                <Typewriter
                  loop
                  cursor
                  cursorStyle="_"
                  typeSpeed={100}
                  deleteSpeed={50}
                  delaySpeed={1000}
                  words={["New Town", "Hoogle", "Durgapur", "Bengalore", "Delhi", "Siliguri", "Murshidabad", "Bengalore", "Chennei", "Rajasthan"]}
                />
              </span>
              </b></h1>
               <div className="indiastrustedwebsitedevelopment">
                <h3 style={{ fontSize: "1rem", color: "white" }} className="card-text mb-8 mt-2"> <b>AT INDIA PACKERS MOVERS</b></h3>
              </div>
              </div>
              <div className="col-md-4 mt-3">
                <div className='packer_Rajarhatkolkata'>
                  <Contactform/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />




       





      </div>
     
      <div className='grey'>
         <br />
        <div className="album py-1">

          <div className="container">
      <center><h2 style={{color:"#05438e"}}>How does it Work?</h2></center>
      </div>
      </div>
       <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">
<WorkProcess/>
              </div>
               <div className="col-md-4 mt-4">
                                 <div className="card" >
  <img src={helpdeskdetails} className="card-img-top" alt="helpdeskdetails"/>
  <div className="card-body">
    <h5 style={{color:"#05438e"}} className="card-title"><center>Helpful Details</center></h5>
    <p className="card-text">Packing tips</p>
  
  </div>
</div>

              </div>
              </div>
              </div>
            </div>
       <br />
      <br />

      </div>
      <ShiftingProcess/>
  

      <Callback/>

     
    </div>
  )
}

export default International